require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./posts-features-mindfull-outbound-campaigns.json") })
        }
      }, "path---posts-features-mindfull-outbound-campaigns");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---posts-features-mindfull-outbound-campaigns!./.cache/json/posts-features-mindfull-outbound-campaigns.json
// module id = 331
// module chunks = 231608221292675